import { render, staticRenderFns } from "./UtilityActionItem.vue?vue&type=template&id=b07f249a&"
import script from "./UtilityActionItem.vue?vue&type=script&lang=ts&"
export * from "./UtilityActionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports